import { CommunityHeader } from "./CommunityHeader";
import { Cover } from "./Cover";
import { PaywallDescription } from "./PaywallDescription";
import { PriceSelector } from "./PriceSelector";
import { Root } from "./Root";

export const CheckoutDescription = Object.assign(Root, {
  Cover,
  PriceSelector,
  CommunityHeader,
  PaywallDescription,
});
